import { required, helpers, minLength, maxLength } from '@vuelidate/validators';
import { computed } from "vue";
import {
    isValidAddress1,
    isValidJapaneseAddress2,
    isValidJapaneseAddress3,
    isValidKana,
    isValidName, isValidTel,
    isValidZipCode
} from "@/validations/common";

export function getAddressRegisterRule(t) {
    return computed(() => {
        return {
            first_name: {
                required: helpers.withMessage(t('ERROR_REQUIRED_FIRST_NAME'), required),
                isValidName: helpers.withMessage(t('ERROR_FIRST_NAME_INPUT_INVALID'), isValidName),
            },
            last_name: {
                required: helpers.withMessage(t('ERROR_REQUIRED_LAST_NAME'), required),
                isValidName: helpers.withMessage(t('ERROR_LAST_NAME_INPUT_INVALID'), isValidName),
            },
            first_name_kana: {
                required: helpers.withMessage(t('ERROR_REQUIRED_FIRST_NAME_KANA'), required),
                isValidKana: helpers.withMessage(t('ERROR_FIRST_NAME_KANA_INPUT_INVALID'), isValidKana),
            },
            last_name_kana: {
                required: helpers.withMessage(t('ERROR_REQUIRED_LAST_NAME_KANA'), required),
                isValidKana: helpers.withMessage(t('ERROR_LAST_NAME_KANA_INPUT_INVALID'), isValidKana),
            },
            tel: {
                required: helpers.withMessage(t('ERROR_REQUIRED'), required),
                minLength: helpers.withMessage(
                    ({ $params }) => t('ERROR_MIN_LENGTH', { min: $params.min }),
                    minLength(10)
                ),
                maxLength: helpers.withMessage(
                    ({ $params }) => t('ERROR_MAX_LENGTH', { max: $params.max }),
                    maxLength(20)
                ),
                isValidTel: helpers.withMessage(t('ERROR_INVALID_PHONE_NUMBER'), isValidTel)
            },
            zip_code: {
                required: helpers.withMessage(t('ERROR_REQUIRED'), required),
                isValidZipCode: helpers.withMessage(t('ERROR_ZIP_CODE_INPUT_INVALID'), isValidZipCode)
            },
            address_1: {
                required: helpers.withMessage(t('ERROR_REQUIRED'), required),
                isValidAddress1: helpers.withMessage(t('ERROR_ADDRESS_1_INPUT_INVALID'), isValidAddress1),
                minLength: helpers.withMessage(
                    ({ $params }) => t('ERROR_MIN_LENGTH', { min: $params.min }),
                    minLength(1)
                ),
                maxLength: helpers.withMessage(
                    ({ $params }) => t('ERROR_MAX_LENGTH', { max: $params.max }),
                    maxLength(100)
                )
            },
            address_2: {
                required: helpers.withMessage(t('ERROR_REQUIRED'), required),
                isValidJapaneseAddress2: helpers.withMessage(t('ERROR_ADDRESS_2_INPUT_INVALID'), isValidJapaneseAddress2)
            },
            address_3: {
                required: helpers.withMessage(t('ERROR_REQUIRED'), required),
                isValidJapaneseAddress3: helpers.withMessage(t('ERROR_ADDRESS_3_INPUT_INVALID'), isValidJapaneseAddress3)
            }
        }
    })
}